import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class ExitFormService {
  headers;
  constructor(private http: HttpClient) {}

  getHeaders() {
    this.headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
      "access-token": localStorage.getItem("access-token"),
      client: localStorage.getItem("client"),
      clientid: localStorage.getItem('client_id'),
      expiry: localStorage.getItem("expiry"),
      uid: localStorage.getItem("uid"),
    });
  }

  createExitForm(value) {
    this.getHeaders();
    return this.http.post(
      environment.offboarding_url + "/exit_interview_form",
      value,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  getExitForm(id) {
    this.getHeaders();
    return this.http.get(
      environment.offboarding_url + "/exit-form/" + id,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }

  updateExitForm(value) {
    this.getHeaders();
    return this.http.put(
      environment.offboarding_url + "/verify_details/",
      value,
      { headers: this.headers, observe: "response" }
    );
  }

  

  getAnswerEx(id) {
    this.getHeaders();
    return this.http.get(
      `${environment.offboarding_url}/exit_details/${id}?category=exit_form`,
      {
        headers: this.headers,
        observe: "response",
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/exit-form.service.ts